import { DialogContent, DialogContentText, Typography } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'
import Slide from '@material-ui/core/Slide'
import { TransitionProps } from '@material-ui/core/transitions'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { useGlobalState } from '../../providers/GlobalState'
import { SuccessButton } from '../Buttons'

const Transition = React.forwardRef(function Transition(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />
})

type SuccessModalProps = {
  handleClose: () => void
  orderResponse: { numberOs: string; message: string }
}

export default function SuccessModal({
  handleClose,
  orderResponse
}: SuccessModalProps): JSX.Element {
  const history = useHistory()
  const { cataractTypes } = useGlobalState()

  const redirect = () => {
    if (cataractTypes && cataractTypes.length > 0) {
      return history.replace(`/nav/catarata/${cataractTypes?.[0]?.slug}`)
    }
    return history.goBack()
  }
  return (
    <Dialog
      open
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
    >
      <DialogTitle>
        <Typography variant="h5" align="center">
          {orderResponse.message}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography variant="h6" align="center">
            Número OS: #{`${orderResponse.numberOs}`.padStart(3, '0')}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <SuccessButton onClick={redirect}>Ok</SuccessButton>
      </DialogActions>
    </Dialog>
  )
}
